/* eslint-disable global-require */
const { NODE_ENV: runtime = 'production' } = process.env;

if (['production', 'test'].some(env => env === runtime.toLowerCase())) {
  module.exports = require('./prod').default;
} else {
  module.exports = require('./dev').default;
}



// WEBPACK FOOTER //
// ./src/store/configureStore.js